export const fetchCountryOptions = async (searchKeyword, setCountryOptions) => {
  // Change the format from "LastName, FirstName" to "FirstName LastName"
  const searchTerm = searchKeyword?.trim();
  try {
    const response = await fetch(`/referenceData/findCountry?name=${ searchTerm }`);
    const data = await response.json();
    const flattenedData = data[0].map((state) => state.name);
    setCountryOptions(flattenedData);
  } catch (error) {
    console.error('Failed to fetch country options', error);
  }
};

export const fetchStateOptions = async (searchKeyword, setStateOptions) => {
  // Change the format from "LastName, FirstName" to "FirstName LastName"
  const searchTerm = searchKeyword?.trim();
  try {
    const response = await fetch(`/referenceData/findState?name=${ searchTerm }`);
    const data = await response.json();
    const flattenedData = data.map((state) => state.abbreviation);
    setStateOptions(flattenedData);
  } catch (error) {
    console.error('Failed to fetch state options', error);
  }
};
